import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { User } from '../_models';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private registrationData: { username: string, password: string; registerAsAdmin: boolean; email: string };
  private updatePasswordData: { oldPassword: string, newPassword };
  private resetLinkData: { email: string };
  private passwordResetData: { password: string, confirmPassword: string, token: string };
  private activateAccountData: { verificationCode: string };

  constructor(private http: HttpClient) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('loggedInClient')));
    this.loggedInClient = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  private currentUserSubject: BehaviorSubject<User>;
  public loggedInClient: Observable<User>;
  public data: { password: string; email: string; deviceInfo: { deviceType: string; deviceId: string; notificationToken: string } };

  public logoutData: { deviceInfo: { deviceType: string; deviceId: string; notificationToken: string } };

  register(username: string, email: string, password: string, registerAsAdmin: boolean) {
    this.registrationData = {
      username,
      email,
      password,
      registerAsAdmin
    };
    return this.http.post<any>(`${environment.apiUrl}/auth/register`, this.registrationData)
      .pipe(map(resp => {
        console.log(resp);
        return resp;
      }));
  }

  login(email: string, password: string) {

    this.data = {
      email,
      password,
      deviceInfo: {
        deviceId: '01234567890',
        deviceType: 'DEVICE_TYPE_ANDROID',
        notificationToken: '67657575eececce34'
      }
    };

    return this.http.post<any>(`${environment.apiUrl}/auth/login`, this.data)
      .pipe(map(resp => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('loggedInClient', JSON.stringify(resp));
        this.currentUserSubject.next(resp);
        return resp;
      }));
  }

  logout() {

    const currentUser = this.currentUserValue;
    this.logoutData = {
      deviceInfo: {
        deviceId: currentUser.deviceId,
        deviceType: 'DEVICE_TYPE_ANDROID',
        notificationToken: '67657575eececce34'
      }
    };

    // remove user from local storage to log user out
    console.log('Logout data....');
    console.log(this.logoutData);

    return this.http.post(`${environment.apiUrl}/v1/user/logout`, this.logoutData)
      .pipe(map(da => {
        this.currentUserSubject.next(null);
      }));

  }

  updatePassword(oldPassword: string, newPassword: string) {

    this.updatePasswordData = {
      oldPassword,
      newPassword
    };
    return this.http.post(`${environment.apiUrl}/v1/user/password/update`, this.updatePasswordData);
  }

  sendPasswordResetLink(email: string) {
    this.resetLinkData = {
      email
    };
    return this.http.post(`${environment.apiUrl}/auth/sendPasswordResetLink`, this.resetLinkData);
  }

  activateAccount(verificationCode: string) {
    this.activateAccountData = {
      verificationCode
    };

    return this.http.post(`${environment.apiUrl}/auth/registrationConfirmation`, this.activateAccountData);
  }

  resetPassword(password: string, confirmPassword: string, token: string) {
    this.passwordResetData = {
      password,
      confirmPassword,
      token
    };

    console.log(this.passwordResetData);
    return this.http.post(`${environment.apiUrl}/auth/password/reset`, this.passwordResetData);
  }
}
